/**
 * @generated SignedSource<<c7444340136d28aa8770d10d0a7d23cc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_itemSearch$data = {
  readonly popularSearchesLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
  };
  readonly " $fragmentType": "SharedRespLinksBlock_itemSearch";
};
export type SharedRespLinksBlock_itemSearch$key = {
  readonly " $data"?: SharedRespLinksBlock_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "0069ae2ec40bcb00d2d82e9a6f8eb1e6";

export default node;
